export const uploadFields = [
  {
    label: 'Primary Identity Photo',
    name: 'primaryIdentityPhotoKey',
    require: true,
    message: 'Please upload a photo ID',
    documentType: 'PRIMARY_IDENTITY_PHOTO',
    url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  },
  {
    label: 'Secondary Identity Photo',
    name: 'secondaryIdentityPhotoKey',
    message: 'Please upload a photo ID',
    documentType: 'SECONDARY_IDENTITY_PHOTO',
    url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  },
  {
    label: 'Kyc Application',
    name: 'kycApplicationKey',
    require: true,
    message: 'Please upload a document',
    documentType: 'KYC_APPLICATION',
    url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  },
  {
    label: 'Household List',
    name: 'houseHoldListKey',
    message: 'Please upload a document',
    documentType: 'HOUSE_HOLD_LIST',
    url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  },
  {
    label: 'Communication Address',
    name: 'communicationAddressKey',
    message: 'Please upload a document',
    documentType: 'COMMUNICATION_ADDRESS',
    url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  },
  {
    label: 'Bank Statement',
    name: 'bankStatementKey',
    require: true,
    message: 'Please upload a document',
    documentType: 'BANK_STATEMENT',
    url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  },
  {
    label: 'Application Form Key',
    name: 'applicationFormKey',
    message: 'Please upload a document',
    documentType: 'APPLICATION_FORM',
    url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  },
  {
    label: 'Signature Proof Key',
    name: 'signatureProofKey',
    message: 'Please upload a document',
    documentType: 'SIGNATURE_PROOF',
    url: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  },
];

export const fieldToPanelMappingForIndividualTrader = {
  tradingAccountType: '3',
  personalAccountType: '4',
  communicationStreet: '5',
  permanentStreet: '6',
  primaryIdentityPhotoKey: '7',
  kycApplicationKey: '7',
  bankStatementKey: '7',
  applicationFormKey: '7',
};
